// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"7dbc419f","990":"70a0f92e"}[chunkId] + ".chunk.js";
};